import { useToast } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { getPlayer } from "../../Services/home";
import { setUserDetails, UserState } from "../../Store/features/userSlice";

export const usePlay = () => {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch();

  // handleGetPlay now accepts explicit ids so it doesn't capture changing selectors
  const handleGetPlay = useCallback(
    async (userId: number = 0, seasonId: number = 0) => {
      const maxRetries = 3;
      let attempts = 0;

      while (attempts < maxRetries) {
        try {
          setLoading(true);
          const response: UserState | undefined = await getPlayer(
            userId,
            seasonId
          );

          if (response) {
            dispatch(
              setUserDetails({
                user: response.user,
                total_goals: response.total_goals,
                goal_count: response.goal_count,
              })
            );
          }
          return;
        } catch (error) {
          attempts++;

          if (attempts >= maxRetries) {
            toast({
              title: "Erro",
              description:
                "Erro ao carregar os dados do jogador após várias tentativas.",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        } finally {
          setLoading(false);
        }
      }
    },
    [dispatch, toast]
  );

  return {
    setLoading,
    loading,
    handleGetPlay,
  };
};
